import { useState } from 'react'
import { SidebarOpenerLink } from 'shared/components/Sidebar/Sidebar.styles'
import { InlineSpinner } from 'shared/components/Spinner'
import { useTeamV3 } from 'shared/hooks/query/useTeamV3'

import { getTeamAndProductName } from '../../helpers/utils'
import { TeamSidebar } from '../Sidebar/TeamSidebar'

interface TeamLinkProps {
  team: { id: string; name?: string; productSubscriptionName?: string }
  children?: React.ReactNode
}

export function TeamLink({ team: partialTeam, children }: TeamLinkProps) {
  const [preload, setPreload] = useState(false)
  const { team } = useTeamV3(partialTeam.id, { enabled: !!partialTeam.id && !partialTeam.name })

  function renderChildren() {
    if (children) return children

    if (!team && !partialTeam.name) return <InlineSpinner size="1em" />

    return (
      <SidebarOpenerLink onMouseOver={() => setPreload(true)}>
        <span>{getTeamAndProductName(team, partialTeam.name, partialTeam.productSubscriptionName)}</span>
      </SidebarOpenerLink>
    )
  }

  return (
    <TeamSidebar teamId={partialTeam.id} preload={preload}>
      {renderChildren()}
    </TeamSidebar>
  )
}
